import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import { setEnqFetchter } from "../Filter/actions";
import {
  addEnquiryFailure,
  addEnquiryNoteFailure,
  //
  addEnquiryNoteSuccess,
  addEnquiryReminderFailure,
  //
  addEnquiryReminderSuccess,
  //
  addEnquirySuccess,
  addEventFailure,
  addEventSuccess,
  deleteEnquiryFailure,
  deleteEnquiryNoteFailure,
  //
  deleteEnquiryNoteSuccess,
  deleteEnquiryReminderNoteFailure,
  //
  deleteEnquiryReminderNoteSuccess,
  //
  deleteEnquirySuccess,
  editEnquiryFailure,
  //
  editEnquirySuccess,
  fetchEnquiries as fetchEnquiriesAction,
  fetchEnquiriesFailure,
  fetchEnquiriesNotesFailure,
  //
  fetchEnquiriesNotesSuccess,
  fetchEnquiriesRemindersFailure,
  //
  fetchEnquiriesRemindersSuccess,
  fetchEnquiriesSuccess,
  getStatsFailure,
  //
  getStatsSuccess,
  //
  getTimeline,
  getTimelineFailure,
  getTimelineSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  saveOutcomeSuccess,
  saveOutcomeFailure,
  //
  saveDocsSuccess,
  saveDocsFailure,
  //
  saveCloseSuccess,
  saveCloseFailure,
  //
  searchContactSuccess,
  searchContactFailure,
  //
  searchEmailSuccess,
  searchEmailFailure,
  //
  editOutcomeSuccess,
  editOutcomeFailure,
  //
  getEnqChartSuccess,
  getEnqChartFailure,
  //
  getClReportSuccess,
  getClReportFailure,
  //
  getAqReportSuccess,
  getAqReportFailure,
  //
  getRefReportSuccess,
  getRefReportFailure,
  //
  getTypeReportSuccess,
  getTypeReportFailure,
  //
  getMapReportSuccess,
  getMapReportFailure,
  //
  getMyTaskSuccess,
  getMyTaskFailure,
  //
  searchUserSuccess,
  searchUserFailure,
  //
  getCountySuccess,
  getCountyFailure,
  //
  updateDoneSuccess,
  updateDoneFailure,
  //
  setDigitalData,
  setRecommData,
  setAdvertData,
  setLocalData,
} from "./actions";
import {
  ADD_ENQUIRY,
  ADD_EVENT,
  ADD_NOTE,
  ADD_REMINDER,
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE,
  EDIT_ENQUIRY,
  FETCH_ENQUIRIES,
  GET_NOTES,
  GET_REMINDERS,
  GET_STATS,
  GET_TIMELINE,
  GET_VIEW_DATA,
  SAVE_DOCS,
  SAVE_OUTCOME,
  SAVE_CLOSE,
  SEARCH_EMAIL,
  SEARCH_CONTACT,
  EDIT_OUTCOME,
  GET_ENQ_CHART,
  GET_CL_REPORT,
  GET_AQ_REPORT,
  GET_REF_REPORT,
  GET_TYPE_REPORT,
  GET_MAP_REPORT,
  GET_MY_TASK,
  SEARCH_USER,
  GET_COUNTY,
  UPDATE_DONE,
} from "./constants";

export function* fetchEnquiriesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/enquiries?${query}`);
    yield put(fetchEnquiriesSuccess(data));
    yield put(setEnqFetchter(true));
  } catch (e) {
    yield put(fetchEnquiriesFailure());
    yield put(setEnqFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiries!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/enquiries/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiry!"));
  }
}

export function* addEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const activeLocation = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation
  );
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert(`Enquiry added successfully!`));
      yield put(addEnquirySuccess());
      if (payload?.history) {
        payload.history.push(`/d/leads/all?location_id=${activeLocation?.id}`);
      }
    }
  } catch (e) {
    yield put(addEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editEnquirySaga({ payload, onEditSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry updated successfully!"));
      yield put(editEnquirySuccess());
      yield put(getViewDataAction(payload.data.id));
      yield put(getTimeline({ enquiry_id: payload.data.id }));
      typeof onEditSuccess === "function" && onEditSuccess(data?.data);
    }
  } catch (e) {
    yield put(editEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const activeLocation = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation
  );

  try {
    const data = yield call(api(token).delete, `/api/enquiries/${payload}`);
    if (data) {
      yield put(successAlert("Enquiry deleted successfully!"));
      yield put(deleteEnquirySuccess());
      yield put(
        fetchEnquiriesAction({
          data: { page: 1, limit: 10, location_id: activeLocation?.id },
        })
      );
    }
  } catch (e) {
    yield put(deleteEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquiryNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiries-notes`, payload);
    if (data) {
      yield put(successAlert("Enquiry Note deleted successfully!"));
      yield put(deleteEnquiryNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteEnquiryNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEnquiryReminderNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/delete-enquiries-reminder`,
      payload
    );
    if (data) {
      yield put(successAlert("Enquiry Reminder Note deleted successfully!"));
      yield put(deleteEnquiryReminderNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteEnquiryReminderNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addEnquiryNoteSaga({ payload, onNoteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries-notes/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry Note added successfully!"));
      yield put(addEnquiryNoteSuccess());
      yield put(getViewDataAction(payload.data.enquiry_id));
      yield put(getTimeline({ enquiry_id: payload.data.enquiry_id }));
      typeof onNoteSuccess === "function" && onNoteSuccess();
    }
  } catch (e) {
    yield put(addEnquiryNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesNotesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiries-notes?${query}`
    );
    yield put(fetchEnquiriesNotesSuccess(data));
  } catch (e) {
    yield put(fetchEnquiriesNotesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiries notes!"));
  }
}

export function* addEnquiryReminderSaga({ payload, onReminderSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries-reminder/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry Reminder added successfully!"));
      yield put(addEnquiryReminderSuccess());
      yield put(getViewDataAction(payload.data.enquiry_id));
      yield put(getTimeline({ enquiry_id: payload.data.enquiry_id }));
      typeof onReminderSuccess === "function" && onReminderSuccess();
    }
  } catch (e) {
    yield put(addEnquiryReminderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesRemindersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiries-reminder?${query}`
    );
    yield put(fetchEnquiriesRemindersSuccess(data));
  } catch (e) {
    yield put(fetchEnquiriesRemindersFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiries notes!"));
  }
}

export function* getTimelineSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiry-timeline?${query}`
    );
    yield put(getTimelineSuccess(data));
  } catch (e) {
    yield put(getTimelineFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching timeline!"));
  }
}

export function* addEventSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiry-event/add`, payload);
    if (data) {
      yield put(successAlert("Event added successfully!"));
      yield put(addEventSuccess());
      yield put(getTimeline({ enquiry_id: payload.enquiry_id }));
    }
  } catch (e) {
    yield put(addEventFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(api(token).get, `/api/enquiry-count?${query}`);
    yield put(getStatsSuccess(data));
  } catch (e) {
    yield put(getStatsFailure());
  }
}

export function* saveDocsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/upload-enquiry-documents`,
      payload.data
    );
    if (data) {
      yield put(getViewDataAction(payload.id));
      yield put(saveDocsSuccess());
      yield put(successAlert("Documents saved successfully!"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(saveDocsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* saveOutcomeSaga({ payload, onSaveSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiry-outcome-add`,
      payload
    );
    if (data) {
      yield put(saveOutcomeSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
      yield put(getTimeline({ enquiry_id: payload.enquiry_id }));
      yield put(successAlert("Outcome saved successfully!"));
      typeof onSaveSuccess === "function" && onSaveSuccess(payload);
    }
  } catch (e) {
    yield put(saveOutcomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* saveCloseSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/close-enquiry/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(getViewDataAction(payload.id));
      yield put(getTimeline({ enquiry_id: payload.id }));
      yield put(saveCloseSuccess());
      yield put(successAlert("Enquiry updated successfully!"));
    }
  } catch (e) {
    yield put(saveCloseFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchContactsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/search-contact?${query}`);
    yield put(searchContactSuccess(data));
  } catch (e) {
    yield put(searchContactFailure());
  }
}

export function* searchEmailSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/search-email?${query}`);
    yield put(searchEmailSuccess(data));
  } catch (e) {
    yield put(searchEmailFailure());
  }
}

export function* editOutcomeSaga({ payload, onEditSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiries-reminder/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(editOutcomeSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
      yield put(getTimeline({ enquiry_id: payload.enquiry_id }));
      yield put(successAlert("Outcome saved successfully!"));
      typeof onEditSuccess === "function" && onEditSuccess(payload);
    }
  } catch (e) {
    yield put(editOutcomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getEnqSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/enquiry-chart?${query}`);
    if (data) {
      yield put(getEnqChartSuccess(data));
    }
  } catch (e) {
    yield put(getEnqChartFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getClSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/close-enquiry-report?${query}`
    );
    if (data) {
      yield put(getClReportSuccess(data));
    }
  } catch (e) {
    yield put(getClReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getAqSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/acquisitions-report?${query}`
    );
    if (data) {
      yield put(getAqReportSuccess(data));
    }
  } catch (e) {
    yield put(getAqReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* gerRefSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.query ? QueryString.stringify(payload?.query) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/acquisitions-report/${payload.type}?${query}`
    );
    if (data) {
      yield put(getRefReportSuccess(data));
    }
  } catch (e) {
    yield put(getRefReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getTypeReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const refTypeReport = yield select(
    (state) => state?.EnquiriesReducer?.refTypeReport
  );
  let query = payload?.query ? QueryString.stringify(payload?.query) : "";
  let type = payload.type.replaceAll(" ", "");

  try {
    const { data } = yield call(
      api(token).get,
      `/api/acquisitions-referrer-report/${payload.type}?${query}`
    );
    let tempData = {
      ...refTypeReport,
      [payload.type.replaceAll(" ", "")]: data ?? [],
    };

    if (type === "Digital") {
      yield put(setDigitalData(data));
    }
    if (type === "Recommendation") {
      yield put(setRecommData(data));
    }
    if (type === "LocalReputation") {
      yield put(setLocalData(data));
    }
    if (type === "Advertising") {
      yield put(setAdvertData(data));
    }

    yield put(getTypeReportSuccess(tempData));
  } catch (e) {
    yield put(getTypeReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getMapReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/enquiry-map-report?${query}`
    );
    if (data) {
      yield put(getMapReportSuccess(data));
    }
  } catch (e) {
    yield put(getMapReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getMyTaskSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/self-upcoming-task?${query}`
    );
    if (data) {
      yield put(getMyTaskSuccess(data));
    }
  } catch (e) {
    yield put(getMyTaskFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchUserSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-user-enquiry?${query}`
    );
    yield put(searchUserSuccess(data));
  } catch (e) {
    yield put(searchUserFailure());
  }
}

export function* getCountySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/group-by-county?${query}`
    );
    if (data) {
      yield put(getCountySuccess(data));
    }
  } catch (e) {
    yield put(getCountyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateDoneSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/enquiry-event-update/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(updateDoneSuccess());
      typeof onUpdate === "function" && onUpdate();
    }
  } catch (e) {
    yield put(updateDoneFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEnquiriesFlow() {
  yield takeEvery(FETCH_ENQUIRIES, fetchEnquiriesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addEnquiryFlow() {
  yield takeEvery(ADD_ENQUIRY, addEnquirySaga);
}
export function* editEnquiryFlow() {
  yield takeEvery(EDIT_ENQUIRY, editEnquirySaga);
}
export function* deleteEnquiryFlow() {
  yield takeEvery(DELETE_ENQUIRY, deleteEnquirySaga);
}
export function* deleteEnquiryNoteFlow() {
  yield takeEvery(DELETE_ENQUIRY_NOTE, deleteEnquiryNoteSaga);
}
export function* deleteEnquiryReminderNoteFlow() {
  yield takeEvery(DELETE_ENQUIRY_REMINDER_NOTE, deleteEnquiryReminderNoteSaga);
}
export function* addEnquiryNoteFlow() {
  yield takeEvery(ADD_NOTE, addEnquiryNoteSaga);
}
export function* fetchEnquiriesNotesFlow() {
  yield takeEvery(GET_NOTES, fetchEnquiriesNotesSaga);
}
export function* addEnquiryReminderFlow() {
  yield takeEvery(ADD_REMINDER, addEnquiryReminderSaga);
}
export function* fetchEnquiriesRemindersFlow() {
  yield takeEvery(GET_REMINDERS, fetchEnquiriesRemindersSaga);
}
export function* getTimelineFlow() {
  yield takeEvery(GET_TIMELINE, getTimelineSaga);
}
export function* addEventFlow() {
  yield takeEvery(ADD_EVENT, addEventSaga);
}
export function* getStatsFlow() {
  yield takeEvery(GET_STATS, getStatsSaga);
}
export function* saveDocsFlow() {
  yield takeEvery(SAVE_DOCS, saveDocsSaga);
}
export function* saveOutcomeFlow() {
  yield takeEvery(SAVE_OUTCOME, saveOutcomeSaga);
}
export function* saveCloseFlow() {
  yield takeEvery(SAVE_CLOSE, saveCloseSaga);
}
export function* searchContactsFlow() {
  yield takeEvery(SEARCH_CONTACT, searchContactsSaga);
}
export function* searchEmailFlow() {
  yield takeEvery(SEARCH_EMAIL, searchEmailSaga);
}
export function* editOutcomeFlow() {
  yield takeEvery(EDIT_OUTCOME, editOutcomeSaga);
}
export function* getEnqFlow() {
  yield takeEvery(GET_ENQ_CHART, getEnqSaga);
}
export function* getClFlow() {
  yield takeEvery(GET_CL_REPORT, getClSaga);
}
export function* getAqFlow() {
  yield takeEvery(GET_AQ_REPORT, getAqSaga);
}
export function* gerRefFlow() {
  yield takeEvery(GET_REF_REPORT, gerRefSaga);
}
export function* getTypeReportFlow() {
  yield takeEvery(GET_TYPE_REPORT, getTypeReportSaga);
}
export function* getMapReportFlow() {
  yield takeEvery(GET_MAP_REPORT, getMapReportSaga);
}
export function* getMyTaskFlow() {
  yield takeEvery(GET_MY_TASK, getMyTaskSaga);
}
export function* searchUserFlow() {
  yield takeEvery(SEARCH_USER, searchUserSaga);
}
export function* getCountyFlow() {
  yield takeEvery(GET_COUNTY, getCountySaga);
}
export function* updateDoneFlow() {
  yield takeEvery(UPDATE_DONE, updateDoneSaga);
}

export default function* EnquiriesSaga() {
  yield all([
    fetchEnquiriesFlow(),
    addEnquiryFlow(),
    editEnquiryFlow(),
    deleteEnquiryFlow(),
    getViewDataFlow(),
    deleteEnquiryNoteFlow(),
    deleteEnquiryReminderNoteFlow(),
    addEnquiryNoteFlow(),
    fetchEnquiriesNotesFlow(),
    addEnquiryReminderFlow(),
    fetchEnquiriesRemindersFlow(),
    getTimelineFlow(),
    addEventFlow(),
    getStatsFlow(),
    saveOutcomeFlow(),
    saveDocsFlow(),
    saveCloseFlow(),
    searchContactsFlow(),
    searchEmailFlow(),
    editOutcomeFlow(),
    getEnqFlow(),
    getClFlow(),
    getAqFlow(),
    gerRefFlow(),
    getTypeReportFlow(),
    getMapReportFlow(),
    getMyTaskFlow(),
    searchUserFlow(),
    getCountyFlow(),
    updateDoneFlow(),
  ]);
}
